import React, { useState } from "react";
import { Button, Checkbox, Confirm, Icon, Modal } from "semantic-ui-react";
import NewPDF from "../layout/NewPDF";
import EditCard from "../layout/PlanCardEdit";
import "./ServiceAgreement.css";
import { compose } from "redux";
import { connect, useDispatch } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import {
  deleteAgreement,
  handleAgreementShow,
} from "../../store/actions/newSignup";

const ServiceAgreement = (props) => {
  const [newAgreement, setNewAgreement] = useState(false);
  const [editAgreement, setEditAgreement] = useState(false);
  const [agreement, setAgreement] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [confirm, setConfirm] = useState(false);

  const dispatch = useDispatch();
  const handleClose = () => {
    props.setOpen(false);
    setNewAgreement(false);
    setDeleteId(null);
    setConfirm(null);
  };

  const handleActiveChange = (data, activeStatus) => {
    const dataType = data.type;
    const typeList =
      dataType === "main"
        ? props.mainType
        : dataType === "athlete"
        ? props.athleteType
        : dataType === "transfer"
        ? props.transferType
        : null;
    if (typeList.length < 1 || (typeList.length === 1 && !activeStatus)) {
      dispatch(handleAgreementShow(data.agreementId, activeStatus));
    }
  };

  return (
    <Modal
      size={!newAgreement ? "large" : "tiny"}
      onClose={handleClose}
      onOpen={() => props.setOpen(true)}
      open={props.open}
    >
      <Modal.Content scrolling className="eventVisitorModal">
        <div className="eventVisitorModalButton">
          <Button floated="left" circular icon="close" onClick={handleClose} />
          {newAgreement || editAgreement ? (
            <Button
              floated="right"
              circular
              color="black"
              basic
              content="Back"
              onClick={() =>
                newAgreement
                  ? setNewAgreement(false)
                  : setEditAgreement(false) && setAgreement(null)
              }
            />
          ) : (
            <Button
              icon="plus"
              floated="right"
              circular
              disabled={newAgreement ? true : false}
              color="green"
              onClick={() => setNewAgreement(true)}
            />
          )}
        </div>
        <div className="plan-data-section">
          {newAgreement ? (
            <NewPDF callClose={() => setNewAgreement(false)} />
          ) : editAgreement ? (
            <EditCard
              plan={agreement}
              callClose={() => {
                setEditAgreement(false);
                setAgreement(null);
              }}
            />
          ) : (
            <>
              <div className="PricePlanHead">
                <h3>Agreements</h3>
              </div>
              <div>
                <ul className="agreementlist">
                  {props.agreements &&
                    props.agreements.length > 0 &&
                    props.agreements.map((agreement, i) => {
                      return (
                        <li key={agreement.agreementId}>
                          <div className="full-agreementlist">
                            <div className="one">
                              <h3>{i + 1}</h3>
                            </div>
                            <div className="two" key={1}>
                              <h3>{agreement.fileName}</h3>
                            </div>
                            <div className="three" key={1}>
                              <h3>{agreement.type}</h3>
                            </div>
                            <div className="four">
                              <div>
                                <Checkbox
                                  toggle
                                  checked={agreement.show}
                                  disabled={
                                    agreement.type === "main"
                                      ? props.mainType.length === 1 &&
                                        !agreement.show
                                      : agreement.type === "athlete"
                                      ? props.athleteType.length === 1 &&
                                        !agreement.show
                                      : agreement.type === "transfer"
                                      ? props.transferType.length === 1 &&
                                        !agreement.show
                                      : false
                                  }
                                  onChange={(e, data) => {
                                    handleActiveChange(agreement, data.checked);
                                  }}
                                />
                              </div>
                              <a
                                href={agreement.fileUrl}
                                target="_blank"
                                download
                                rel="noreferrer"
                              >
                                <Button
                                  className="middlebutton"
                                  circular
                                  icon="eye"
                                  color="blue"
                                  name="see Button"
                                />
                              </a>
                              <Button
                                circular
                                icon="trash"
                                color="red"
                                name="editedButton"
                                onClick={() => {
                                  setConfirm(true);
                                  setDeleteId(agreement.agreementId);
                                }}
                              />
                            </div>
                          </div>
                        </li>
                      );
                    })}
                </ul>
              </div>
            </>
          )}
          <Confirm
            open={confirm}
            content="You Sure Want To Delete ?"
            onCancel={() => {
              setConfirm(false);
              setDeleteId(null);
            }}
            onConfirm={() => {
              dispatch(deleteAgreement(deleteId));
              setConfirm(false);
              setDeleteId(null);
            }}
          />
        </div>
      </Modal.Content>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  let agreements = [];
  const agreementsData = state.firestore.data.testAgreements;
  const mainType = [];
  const athleteType = [];
  const transferType = [];
  if (agreementsData) {
    const keys = Object.keys(agreementsData);
    keys.length > 0 &&
      keys.forEach((key) => agreements.push(agreementsData[key]));
  }

  agreements = agreements
    .filter((price) => price && Object.keys(price).length > 0)
    .sort((a, b) => a.amount - b.amount);
  agreements.forEach((e) => {
    if (e.type === "main" && e.show) {
      mainType.push(e);
    }
    if (e.type === "athlete" && e.show) {
      athleteType.push(e);
    }
    if (e.type === "transfer" && e.show) {
      transferType.push(e);
    }
  });
  return {
    agreements,
    auth: state.firebase.auth,
    superAdmin: state.auth.superAdmin,
    mainType,
    athleteType,
    transferType,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => {
    const firestoreArray = [
      {
        collection: "testAgreements",
      },
    ];
    return firestoreArray;
  })
)(ServiceAgreement);
